<template>
  <div class="row full-height background-spacing-color valign-wrapper">
    <div class="row white-background center-align z-depth-3">

      <!-- Email Screen -->
      <div class="row box-size-full">
        <div class="row page-body-height">
          <div class="app-body-height">

            <div class="row">
              <div class="card-padding left-align">
                <div class="col s6">
                  <h5 class="blue-color">{{ $t('views.login.header') }}</h5>
                  <p>{{ $t('views.login.discription')}}</p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="card-padding left-align">
                <form>
                  <div class="row">
                    <div class="input-field col s8 offset-s2 no-margin-bottom">
                      <input
                        id="email"
                        type="email"
                        class="validate"
                        required
                        v-model="emailaddress">
                      <label for="email">{{ $t('views.login.email') }}</label>
                      <span
                        class="helper-text"
                        data-error="Email address format is incorrect" />
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="row">
              <div class="card-padding left-align">
                <div class="col s12">
                  <p>{{ $t('views.login.purpose') }}</p>
                </div>
              </div>
            </div>

          </div>
            <div class="app-footer-height valign-wrapper">
              <div class="row button-padding">
                <div class="col s12">
                  <a
                    @click="acceptDisclaimer()"
                    class="validate waves-effect waves-light btn continue-button">{{ $t('views.login.continue') }}</a>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      emailaddress: ''
    }
  }
}
</script>

<style>
  .button-padding {
    padding-top: 40px;
  }

  .continue-button {
    background-color: #56CCF2;
    min-width: 94px;
  }

  .page-body-height {
    height: 100%;
  }

  .login-error {
    font-size: 12px;
    color:red;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .error-padding {
    padding-left: 45px;
    padding-right: 45px;
  }

  .card-padding {
    padding-top: 24px;
    padding-left: 45px;
    padding-right: 45px;
  }

  .card-content-scroll {
    color: black;
    overflow-y: scroll;
    height: 100%;
    resize: none;
  }
  .card-content-height {
    height: 330px;
  }

  .grey-color {
    color: rgba(0, 0, 0, 0.38);
  }

  .blue-color {
    color: #56CCF2;
  }

  h5 {
    font-size: 24px;
    font-family:Roboto;
    font-weight: 200;
    font-style: normal;
    line-height: normal;
  }
  p {
    font-family:Roboto;
    font-weight: 100;
  }

  .white-background {
    background-color: white;
  }

  .no-border {
    border: none;
    border-bottom: none;
  }

  .no-margin {
    margin: 0px;
  }

  .no-margin-bottom {
    margin-bottom: 0px;
  }

  .no-padding-left {
    padding-left: 0px !important;
  }

  .no-padding-right {
    padding-right: 0px;
  }

  *:focus {
    outline: 0;
  }

  .iagree-button {
    background-color: #56CCF2;
    min-width: 94px;
  }

  .box-size-full {
    width: 806px;
    height: 592px;
  }

  .background-spacing-color {
    background-color: #F2F2F2;
  }
/* CUSTOM INPUT FIELD COLORS */
 /* label color */
   .input-field label {
      color: rgba(0, 0, 0, 0.38);
   }
   /* label focus color */
   .input-field input[type=email]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }
    .input-field input[type=text]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }
    .input-field input[type=password]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }

   /* label underline focus color */
   .input-field input[type=email]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
      /* label underline focus color */
   .input-field input[type=text]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
    .input-field input[type=password]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }

   /* valid color */
   .input-field input[type=email].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
      .input-field input[type=text].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
   .input-field input[type=password].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }

</style>



// WEBPACK FOOTER //
// src/pages/login/VerifyEmail.vue